@switch (resultStatus) {
    @case (ResultStatusType.NUMBER_1) {
        <div>
            <span class="text-danger"><i class="fas fa-times-circle fa-lg"></i></span>
        </div>
    }
    @case (ResultStatusType.NUMBER_0) {
        <div>
            <span class="text-success"><i class="fas fa-check-circle fa-lg"></i></span>
        </div>
    }
}
